const html = require("./html/detailPickupQuoteView.html");
import AsnDetailStore from "../../../stores/AsnDetailStore";
import AsnStore from "../../../stores/AsnStore";
import AsnShippingPalletStore from "../../../stores/AsnShippingPalletStore";
import {setElementsFromScope, show, hide} from "../../../utilities/selectorHelpers";
import {isPresent} from "../../../utilities/general";
import _ from "underscore";
import $ from "jquery";
import AsnDetailRowsView from "./AsnDetailRowsView";
import PickupSchedulingView from "./PickupSchedulingView";
import RequestQuoteView from "./RequestQuoteView";

const elementsMap = {
  asnDetailRowsViewEntryPoint: ".asn-detail-rows-view-entry-point",
  pickupSchedulingEntryPoint: ".pickup-scheduling-entry-point",
  requestQuoteEntryPoint: ".request-quote-entry-point",

  asnDetailRowsSection: ".asn-detail-rows-section",
  asnShippingPalletRowsSection: ".asn-shipping-pallets-rows-section",
  pickupSchedulingSection: ".pickup-scheduling-section",
  requestQuoteSection: ".request-qoute-section",
  moreInfoShippingMessage: ".more-info-shipping-outer"
};

export default function DetailPickupQuoteView(_unused,
  {
    getAsn,
    getAsnDetailGroups,
    csrEmailUrl,
    onAsnDetailGroupFieldChange,
    hasShippingPartnerSelected,
    hasShippingPartner,
    onAsnFieldChange,
    onAsnFieldsChange,
    onRequestQuoteClicked,
    isPallet,
    readOnly,
    didAttemptToNavigateAwayFromCurrentForm
  }){
  const self = this;
  self._element = $();
  const els = {};

  self.init = function(){
    render();
  };

  self.getElement = function(){
    return self._element;
  }

  function render(){
    self._element = $(html);
    setElements();
    setWidgets();
    bindStores();
    updateSelf();
  }

  function updateSelf(){
    toggleSubViews();
  }


  function toggleSubViews(){
    // if nothing selected, show no subview
    hideAllSubviews();
    if(hasShippingPartnerSelected()){
      if(hasShippingPartner()){
        if(isPallet()){
          show(els.asnDetailRowsSection);
          show(els.pickupSchedulingSection);
          show(els.requestQuoteSection);
        }else if(!isPallet()){
          const freightShipping = hasFreigthSelected(getAsn());
          if(isPresent(freightShipping)){
            if(freightShipping){
              show(els.asnShippingPalletRowsSection);
              show(els.pickupSchedulingSection);
              show(els.requestQuoteSection);
            }else{
              show(els.asnDetailRowsSection);
              show(els.moreInfoShippingMessage);
            }
          }
        }
      }
    }
  }

  function hideAllSubviews(){
    hide(els.moreInfoShippingMessage);
    hide(els.asnDetailRowsSection);
    hide(els.pickupSchedulingSection);
    hide(els.requestQuoteSection);
    hide(els.asnShippingPalletRowsSection)
  }

  function bindStores(){
    AsnStore.bindListener("asns:shipping_method_changed", updateSelf);
    AsnStore.bindListener("asns:shipping_partner_changed", updateSelf);
    AsnStore.bindListener("asns:freight_shipping_change", updateSelf);
  }

  function setElements(){
    setElementsFromScope(els, elementsMap, self._element);
  }

  function setWidgets(){
    const asnDetailRowsView = new AsnDetailRowsView(null, {
      getAsn,
      getAsnDetailGroups,
      onAsnDetailGroupFieldChange,
      isPallet,
      readOnly
    });
    asnDetailRowsView.init();

    els.asnDetailRowsViewEntryPoint.html(asnDetailRowsView.getElement());


    const pickupSchedulingView = new PickupSchedulingView(null, {
      getAsn,
      isPallet,
      onAsnFieldChange,
      onAsnFieldsChange,
      readOnly
    });
    pickupSchedulingView.init();
    els.pickupSchedulingEntryPoint.html(pickupSchedulingView.getElement());


    const requestQuoteView = new RequestQuoteView(null, {
      onRequestQuoteClicked,
      getAsn,
      isPallet,
      onAsnFieldsChange,
      csrEmailUrl,
      didAttemptToNavigateAwayFromCurrentForm,
      readOnly
    });
    requestQuoteView.init();
    els.requestQuoteEntryPoint.html(requestQuoteView.getElement());
  }

  function hasFreigthSelected(asn){
    return AsnStore.hasFreigthSelected(asn.id);
  }
}


// WEBPACK FOOTER //
// ./src/pages/asns/ShippingTab/DetailPickupQuoteView.js